import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Biblioteca } from "../../types"
import { Button } from "@inmagik/magik-ui"
import { initialValuesBiblioteca, validationSchemaBiblioteca } from "./BibliotecaCommon"
import { useMemo } from "react"
import BibliotecaForm from "./BibliotecaForm"

export default function BibliotecaModal({
  title,
  biblioteca,
  save,
  show,
  onClose,
}: {
  title: string
  biblioteca?: Biblioteca
  save: (values: Biblioteca, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
}) {
  const initialValues = useMemo(() => initialValuesBiblioteca(biblioteca) as Biblioteca, [biblioteca])
  const validationSchema = useMemo(() => validationSchemaBiblioteca(), [])

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <BibliotecaForm col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
